export class APIError extends Error {
    readonly code: string;
    readonly status: number;
    constructor(message: string, code: string, status: number) {
        super(message);
        this.name = 'APIError';
        this.code = code;
        this.status = status;
    }
}

const configuredBase = import.meta.env.VITE_API_BASE_URL?.trim() || '/api';
const apiBase = configuredBase.replace(/\/$/, '');

export async function request<T>(path: string, body?: unknown, key?: string, signal?: AbortSignal): Promise<T> {
    let response: Response;
    try {
        response = await fetch(`${apiBase}/hotel/${path}`, {
            method: body === undefined ? 'GET' : 'POST',
            headers: {
                Accept: 'application/json',
                ...(body === undefined ? {} : { 'Content-Type': 'application/json', 'X-Hotel-Demo': '1' }),
                ...(key ? { 'Idempotency-Key': key } : {}),
            },
            body: body === undefined ? undefined : JSON.stringify(body),
            signal,
            cache: 'no-store',
        });
    } catch (error) {
        if (signal?.aborted) throw error;
        throw new APIError('The server could not be reached. For booking requests, retry without changing the form so the same request key is reused.', 'NETWORK_ERROR', 0);
    }
    const payload = await response.json().catch(() => null);
    if (!response.ok) throw new APIError(payload?.message || 'The server could not complete this request.', payload?.code || 'REQUEST_FAILED', response.status);
    if (payload === null) throw new APIError('The server returned an unexpected response.', 'INVALID_RESPONSE', response.status);
    return payload as T;
}

export function errorMessage(error: unknown): string {
    return error instanceof Error ? error.message : 'Something went wrong. Please try again.';
}
